(() => {
  const fallback = document.querySelector('[data-cw-search-fallback]');
  if (!fallback) return;
  fallback.hidden = true;

  const form = fallback.querySelector('form');
  const input = form.elements.q;
  input.value = new URLSearchParams(window.location.search).get('q') || '';

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    // Searchanise rewrites form actions; the recovery route must stay native.
    const url = new URL(form.dataset.nativeSearchUrl || form.action, window.location.origin);
    url.searchParams.set('q', input.value);
    url.searchParams.set('type', 'product');
    window.location.assign(url.href);
  }, true);

  let fallbackTimer;
  const update = () => {
    const results = document.querySelector('#snize_results');
    const renderedState = results?.querySelector('.snize-product, .snize-no-products-found');
    if (!renderedState?.getClientRects().length) return false;

    // Empty results are a successful app render too. Once ready, filtering or
    // pagination must never bring the theme form back between app renders.
    fallback.hidden = true;
    window.clearTimeout(fallbackTimer);
    observer.disconnect();
    return true;
  };

  const observer = new MutationObserver(update);
  observer.observe(document.querySelector('#main'), {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });

  // Keep the first paint free of the recovery form, even on a cold app load.
  // A failed app still leaves a usable native search after the grace period.
  if (!update()) {
    fallbackTimer = window.setTimeout(() => {
      if (!update()) fallback.hidden = false;
    }, 12000);
  }
})();
